/**
 * The fee schedules page's tabs, as their path segments (#6716): the templates a reader keeps, and the
 * fee schedules hired work uses. Each has its own Archived chip; the archive is not a tab.
 */
export enum PageTab {
  Templates = 'templates',
  InUse = 'in-use'
}
